import React, { Component } from 'react';
import { Text } from 'react-konva';
import {
  textareaFontColor,
  isDevelopment,
} from '../../library/constants';
import {
  isMobilePhone,
} from '../../library/calc';

class Content extends Component {

  constructor(props){
    super(props);

    this.state = {
      contentShownInToolTip: undefined,
    }

  }

  componentDidMount(){

    if(this.props.runTranslatePhraseInToolTip){

      const phrase = (

        isDevelopment

          ?

        this.props.contentShownInToolTip

          :

        window.trl(this.props.contentShownInToolTip, null, { profile: this.props.translateVarStrInToolTip }));

      this.setState({
        contentShownInToolTip: phrase
      });

    } else {

      this.setState({
        contentShownInToolTip: this.props.contentShownInToolTip
      });
    }

  }

  render () {

    if( typeof(this.state.contentShownInToolTip) === 'undefined' ) return null;

    let {
      left,
      top,
    } = this.props;

    const {
      leftStart4Boxes,
      topLabel,
      fontSizeMatchLabel,
      fontFamilyMatchLabel,
      stopStageClickPropagation,
      widthOfBubble,
    } = this.props;

    left += leftStart4Boxes;
    top += topLabel;

    return (
      <Text
        x={left}
        y={top}
        text={this.state.contentShownInToolTip}
        fontSize={fontSizeMatchLabel}
        fontFamily={fontFamilyMatchLabel}
        fill={textareaFontColor}
        width={widthOfBubble}
        align={'left'}
        onTouchStart={()=>{
          stopStageClickPropagation({fromWhere:'bubble tooltip content A'});
        }}
        onClick={()=> {
          if(isMobilePhone() ) return;
          stopStageClickPropagation({fromWhere:'bubble tooltip content B'});}}
      />
    );
  }
}

export default Content;
